var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"page-back",style:(_vm.style)},[_c('img',{directives:[{name:"show",rawName:"v-show",value:(_vm.backState),expression:"backState"}],attrs:{"src":require("./back.png")},on:{"click":_vm.back}})])}
var staticRenderFns = []

export { render, staticRenderFns }